import { actionTypes } from "app/store/modules/actions/file-rename-rules.actions";

const initialState = {
  list: [],
  selectedRule: null,
  placeholders: [],
  documentTypes: [],
  lenders: [],
  page: 0,
  filter: {
    search: "",
    order: "asc",
    orderBy: "name",
    documentTypes: [],
  },
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FILE_RENAME_RULES_LOADED: {
      const { list } = action.payload;
      return {
        ...state,
        list,
      };
    }

    case actionTypes.FILE_RENAME_RULE_LOADED: {
      const { rule } = action.payload;
      return {
        ...state,
        selectedRule: rule,
      };
    }

    case actionTypes.FILE_RENAME_PLACEHOLDERS_LOADED: {
      const { placeholders } = action.payload;
      return {
        ...state,
        placeholders,
      };
    }

    case actionTypes.FILE_RENAME_RULE_CREATED:
    case actionTypes.FILE_RENAME_RULE_UPDATED:
    case actionTypes.FILE_RENAME_RULE_REMOVED: {
      // No direct state update, handled by reload of list
      return state;
    }

    case actionTypes.FILE_RENAME_DOCUMENT_TYPES_LOADED: {
      const { documentTypes } = action.payload;
      return {
        ...state,
        documentTypes,
      };
    }

    case actionTypes.FILE_RENAME_LENDERS_LOADED: {
      const { lenders } = action.payload;
      return {
        ...state,
        lenders,
      };
    }

    case actionTypes.CHANGE_PAGE: {
      return {
        ...state,
        page: action.payload.page,
      };
    }

    case actionTypes.UPDATE_FILTER: {
      return {
        ...state,
        page: 0,
        filter: {
          ...state.filter,
          ...action.payload.data,
        },
      };
    }

    case actionTypes.SET_SELECTED_RULE: {
      return {
        ...state,
        selectedRule: action.payload.rule,
      };
    }

    default:
      return state;
  }
};
